module.exports = __webpack_public_path__ + "static/media/no_image.d9aea7c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/containers/embeddable/utils/no_image.png
// module id = 26
// module chunks = 1